import { Modal } from '@/components';
import { useTranslation } from 'react-i18next';
import { EditAutomationCostForm } from './EditAutomationCostForm';

type EditAutomationCostModalButtonProps = {
  automationId: number;
  infrastructureCostId: number;
  startDate?: Date;
  endDate?: Date;
  isOpen: boolean;
  onClose: () => void;
};

export const EditAutomationCostModal = ({
  automationId,
  infrastructureCostId,
  startDate,
  endDate,
  isOpen,
  onClose,
}: EditAutomationCostModalButtonProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('edit_automation_cost')}
      className="flex h-fit w-128 flex-col gap-4"
      isOpen={isOpen}
      handleClose={onClose}
    >
      <EditAutomationCostForm
        infrastructureCostId={infrastructureCostId}
        automationId={automationId}
        defaultValues={{ startDate, endDate }}
        onCancel={onClose}
        onSubmit={onClose}
      />
    </Modal>
  );
};
